import { render, staticRenderFns } from "./SuccessColleagueOrders.vue?vue&type=template&id=38683960&scoped=true&"
import script from "./SuccessColleagueOrders.vue?vue&type=script&lang=js&"
export * from "./SuccessColleagueOrders.vue?vue&type=script&lang=js&"
import style0 from "./SuccessColleagueOrders.vue?vue&type=style&index=0&id=38683960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38683960",
  null
  
)

export default component.exports